import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;
Wrapper.displayName = 'Wrapper';

export const Titles = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 50px;
`;
Titles.displayName = 'Titles';

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0px 40px;
  color: ${({ theme }) => theme.text.tab};
  background: ${({ theme, selected }) => selected ? theme.tab.selected : theme.tab.item};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
Title.displayName = 'Title';

export const Contents = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.tab.selected};
  overflow: hidden;
`;
Contents.displayName = 'Contents';
